<div class="c-header__row">
    <div class="c-header__row">

        <div class="c-header__group">

            <h2 class="c-header__heading u-heading">{{ 'voyage.title' | translate }} {{ activeVoyage()?.voyageNumber }}
            </h2>

        </div>

        <div class="c-header__group">

            <div class="c-bulleted-text">
                <span>{{ activeVoyage()?.vesselDetails?.vesselName }}</span>
                <span>{{ 'voyage.imo' | translate}}: {{ activeVoyage()?.vesselDetails?.imoNumber }}</span>
                <span>{{ activeVoyage()?.vesselDetails?.typeOfVessel | uppercase }}</span>
            </div>

        </div>
    </div> <!-- .c-header__row -->
    <div class="c-header__group">
        <div class="c-header-switch">
            <button type="button" class="c-header-switch__btn" [title]="'voyage.listView' | translate"
                (click)="onChangeRouteView(voyageRouteViews.list)"
                [class.is-active]="activeRouteView() === voyageRouteViews.list">
                <span class="fa fa-ellipsis"></span>
            </button>
            <button type="button" class="c-header-switch__btn" [title]="'voyage.cardView' | translate"
                (click)="onChangeRouteView(voyageRouteViews.card)"
                [class.is-active]="activeRouteView() === voyageRouteViews.card">
                <span class="fa-solid fa-solid fa-grid-2"></span>
            </button>
        </div>
    </div>
</div>